var applicableStyles = [
    'top',
    'right',
    'left',
    'bottom',
    'height',
    'maxHeight',
    'width',
    'marginLeft',
    'marginRight',
    'marginTop',
    'marginBottom',
    'maxWidth',
    'minWidth',
    'paddingRight',
    'paddingLeft',
    'paddingTop',
    'paddingBottom',
    'position',
    'overflow',
    'zIndex'
];
export function applyStyles(node, styles) {
    if (!node) {
        return false;
    }
    // In this case it is the first execution,
    // we want to apply all of the styles immediately,
    // in order to avoid blinking.
    if (!node.hasAttribute('style')) {
        node.style.transitionDuration = '0ms';
    }
    else {
        node.style.transitionDuration = null;
    }
    return applicableStyles.reduce(function (hasChanged, property) {
        var oldValue = node.style[property];
        var newValue = styles[property];
        if (typeof newValue === 'undefined') {
            newValue = '';
        }
        if (typeof newValue === 'number') {
            newValue = property === 'zIndex' ? "" + newValue : newValue + "px";
        }
        if (oldValue === newValue) {
            return hasChanged;
        }
        node.style[property] = newValue;
        return true;
    }, false);
}
export function applyClass(node, className, shouldContain) {
    var containsClass = node.classList.contains(className);
    if (containsClass === shouldContain) {
        return false;
    }
    if (shouldContain) {
        node.classList.add(className);
    }
    else {
        node.classList.remove(className);
    }
    return true;
}
export function any(arrayOfBooleans) {
    // TODO [mjawors] _.any
    return arrayOfBooleans.some(function (value) { return value; });
}
export function isMobileView() {
    // replace with $breakpoint-x-small value after https://issues.amazon.com/issues/AWSUI-3532 is done
    return window.innerWidth <= 768;
}
//# sourceMappingURL=utils.js.map